import React from 'react'

export default function ChurchLinks() {
  return (
    <div>ChurchLinks</div>
  )
}
